export default __webpack_public_path__ + "static/media/snail.0ccad7a4.svg";